import React, { Component } from 'react';

import uuid from 'uuid/v4';

import { Endpoint, shouldRenderMobile } from '@philips-emr/hpms-stipulator-commons';
import { Autocomplete, Button, Card, Fetch, Field, Form, Input, Mapper, Panel, Text } from '@philips-emr/tws-components';
import { bool, eventListener, object } from '@philips-emr/tws-core/lib/component/prop-types';
import { isFunction } from '@philips-emr/tws-utils';

import './hpms-guia-analise.scss';

export default class HpmsGuiaAnaliseCard extends Component {

  static propTypes = {
    hiddenContextMenu: bool,
    onChange: eventListener,
    onInformarParecerClick: eventListener,
    readonly: bool,
    setRecord: eventListener,
    value: object.notEnumerable(),
  };

  static defaultProps = {
    hiddenContextMenu: false,
    readonly: false,
    value: {},
  };

  internalOnChange = (event) => {
    const { value } = event;
    const { situacao, qtAutorizada = '', nrSequencia } = value;
    const { value: itemValue, onChange } = this.props;

    const propagateOnChange = (itemValue) => {
      if (isFunction(onChange)) {
        onChange({
          value: itemValue,
          entry: nrSequencia,
        });
      }
    }

    if (situacao && situacao.cdSituacao === 'N') {
      propagateOnChange({
        ...itemValue,
        qtAutorizada: '0',
        situacao,
        qtAutorizadaEnabled: false,
      });

    } else {
      delete itemValue.situacao;
      propagateOnChange({
        ...itemValue,
        qtAutorizada: qtAutorizada == '0' ? '' : qtAutorizada,
        ...(situacao && { situacao }),
        qtAutorizadaEnabled: true,
      });
    }
  };

  getWidth(width) {
    return shouldRenderMobile() ? 12 : width;
  }

  renderCard(data) {
    const { onInformarParecerClick, readonly, hiddenContextMenu } = this.props;
    const validators = !readonly ? [{ name: 'required', options: {} }] : undefined;
    const { dsTipo, situacao, ieStatus } = data;
    const border = situacao ? situacao.cdSituacao : 'P';

    return (
      <Card key="card-guia-itens-analise" width={12} uuid={uuid()} className={`c-card__content c-hpms-guia-itens-analise__card c-hpms-guia-itens-analise__border-${readonly && border === 'P' ? ieStatus : border}`}>
        <Panel uuid={uuid()}>
          <Form data={data} editing={!readonly} disabled locked uuid={uuid()} className="c-hpms-guia-itens-analise__form" onChange={this.internalOnChange}>
            {readonly && <Field width={this.getWidth(6)} uuid={uuid()} alwaysShowLabel label={dsTipo} entry="dsProcMat"><Text /></Field>}
            {!readonly && <Field width={this.getWidth(2)} uuid={uuid()} alwaysShowLabel label="stipulator.tipo" entry="dsTipo"><Text /></Field>}
            {!readonly && <Field width={this.getWidth(4)} uuid={uuid()} alwaysShowLabel label="stipulator.descricao" entry="dsProcMat"><Text /></Field>}
            <Field width={this.getWidth(2)} uuid={uuid()} alwaysShowLabel label="stipulator.solicitado" entry="qtSolicitada"><Text /></Field>
            <Field width={this.getWidth(2)} uuid={uuid()} alwaysShowLabel label="stipulator.aprovado" entry="qtAutorizada" validators={validators}>
              <Input uuid={uuid()} max={data.qtSolicitada} showLength={false} enabled={data.qtAutorizadaEnabled} />
            </Field>
            {readonly && border === 'P'
              ? <Field width={this.getWidth(2)} uuid={uuid()} alwaysShowLabel label="stipulator.situacao" entry="dsSituacao">
                <Text />
              </Field>
              : <Field width={this.getWidth(2)} uuid={uuid()} alwaysShowLabel label="stipulator.situacao" entry="situacao" validators={validators}>
                <Fetch uuid={uuid()} endpoint={Endpoint.GET.SOLICITACAO_SITUACOES}>
                  <Autocomplete uuid={uuid()} entry="dsSituacao" primaryKey="cdSituacao" queryKey="dsSituacao" minSearchLength={0}>
                    <Mapper component="Text" map={{ value: 'dsSituacao' }}>
                      <Text />
                    </Mapper>
                  </Autocomplete>
                </Fetch>
              </Field>
            }
          </Form>
        </Panel>
        ({isFunction(onInformarParecerClick) && readonly && !hiddenContextMenu && (
          <Panel uuid={uuid()} alignItems="flex-end" justifyContent="center" className="c-hpms-guia-itens-analise__menu">
            <Button
              key="detalhes"
              icon="/static/assets/report.svg"
              theme="quiet-emphasis"
              value=""
              iconPlacement="left"
              onClick={() => onInformarParecerClick({ value: data })}
            />
          </Panel>
        )})
      </Card >
    );
  }

  render() {
    const { value } = this.props;

    return this.renderCard(value);
  }
}
